import { render, staticRenderFns } from "./admin-setting-aspect-form.vue?vue&type=template&id=7208d63b"
import script from "./admin-setting-aspect-form.vue?vue&type=script&lang=js"
export * from "./admin-setting-aspect-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports